// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WTP2h","index":"styles_index__2By2k"};